export default __webpack_public_path__ + "static/media/logo-ae-Namshi.fa062174.svg";